import React, { Component, Fragment } from 'react';
import { toastr } from "react-redux-toastr"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import ReactDatatable from '@ashvin27/react-datatable';
import { getData, enviaCustGprPcgRegistros, getDataTdsRevendas } from "./custGrpPcgActions"
import { logout } from "./../../../auth/authActions"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from "react-bootstrap";

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

class CustGprPcg extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []

            , arrayEnviarTodos_groupId: []
            , arrayEnviarTodos_customerId: []

            , arrayEnviar_groupId: []
            , arrayEnviar_customerId: []

            , SelPuxada: 0
            , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)
            , MsgModal2: ""
            , isModalOpen: 0
        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.props.getData(this.props.codPuxada);
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action1",
                text: "",
                className: "action1",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "resellerID",
                text: "ResellerID",
                className: "resellerID",
                sortable: true
            },
            {
                key: "groupId",
                text: "GroupId",
                className: "groupId",
                sortable: true
            },
            {
                key: "customerId",
                text: "CustomerId",
                className: "customerId",
                sortable: true,
                align: "left",
                width: 200

            },
            {
                key: "createdAtStaging",
                text: "CreatedAtStaging",
                className: "createdAtStaging",
                sortable: true,
                align: "left",
                width: 200

            },
            {
                key: "updatedAtStaging",
                text: "UpdatedAtStaging",
                className: "updatedAtStaging",
                sortable: true,
                align: "left",
                width: 200

            },
            {
                key: "sendToHybrisStatus",
                text: "SendToHybSts",
                className: "sendToHybrisStatus",
                sortable: true,
                align: "left"

            },
            {
                key: "sendToHybrisAt",
                text: "SendToHybrisAt",
                className: "sendToHybrisAt",
                sortable: true,
                align: "left",
                width: 200
            },

        ];
        this.config = {
            key_column: 'resellerID,groupId,customerId',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "CustGprPcg",

            language: {
                loading: "True",
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
            }

        }

        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>
                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>

                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);
        this.PopulararrayEnviarTodos = this.PopulararrayEnviarTodos.bind(this);
        this.setbscInf = this.setbscInf.bind(this);
        this.setPuxada = this.setPuxada.bind(this);

    }

    setPuxada(e) {
        this.setState({
            SelPuxada: (e.target.value === "" ? 0 : e.target.value)
            , booLerRecords: false
        });
    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0, LimpaRegReposta: true })

    setbscInf() {
        if (this.state.SelPuxada === null || Number(this.state.SelPuxada) === 0 || this.state.SelPuxada === undefined) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {
            this.setState({
                MsgModal2: "Processando solicitação..."
            });
            this.openModal(2)
            this.props.getData(this.state.SelPuxada);
            setTimeout(() => {
                this.setState({
                    booLerRecords: true
                    , isModalOpen: 0
                });
            }, 500);
        }
    }

    PopulararrayEnviarTodos() {

        this.setState({
            arrayEnviarTodos_groupId: []
            , arrayEnviarTodos_customerId: []
        });
        if (this.props.redListaCustGprPcg !== undefined && this.props.redListaCustGprPcg !== null) {
            for (let i = 0, l = this.props.redListaCustGprPcg.length; i < l; i++) {
                this.state.arrayEnviarTodos_groupId.push(this.props.redListaCustGprPcg[i].groupId);
                this.state.arrayEnviarTodos_customerId.push(this.props.redListaCustGprPcg[i].customerId);
            }
        }
    }
    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2_groupId = [];
        const array2_customerId = [];

        let Existe = [{}];

        Existe =
            (
                this.state.arrayMarcados
                    .filter((a) => a.groupId === registro.groupId &&
                        a.customerId === registro.customerId
                    )
            )


        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)

            this.state.arrayEnviar_groupId.push(registro.groupId);
            this.state.arrayEnviar_customerId.push(registro.customerId);

        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].groupId === registro.groupId &&
                    this.state.arrayMarcados[i].customerId === registro.customerId) { }
                else {
                    array1.push(this.state.arrayMarcados[i]);
                    array2_groupId.push(this.state.arrayMarcados[i].groupId);
                    array2_customerId.push(this.state.arrayMarcados[i].customerId);
                }
            }

            this.setState({
                arrayEnviar_groupId: array2_groupId
                , arrayEnviar_customerId: array2_customerId
                , arrayMarcados: array1
            });

        }
        // console.log("Existe: " + Existe.length)
        // console.log("arrayEnviar_groupId: " + this.state.arrayEnviar_groupId)
        // console.log("arrayEnviar_customerId: " + this.state.arrayEnviar_customerId)
        // console.log("arrayMarcados: " + this.state.arrayMarcados)

    }

    ExportaSelecao() {
        if (this.state.arrayMarcados.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaCustGprPcgRegistros(
                this.state.arrayEnviar_groupId
                , this.state.arrayEnviar_customerId
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_groupId: []
                    , arrayEnviar_customerId: []
                    , isModalOpen: 0
                });
            }, 4000);

        }

    }

    ExportaTodos() {

        this.PopulararrayEnviarTodos();
        let podeenviar = true;

        if (this.state.arrayEnviarTodos_groupId.length === 0) {
            toastr.warning("Não há Grupo e Custo a enviar !!!!")
            podeenviar = false
        }
        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (this.state.SelPuxada === undefined
                || this.state.SelPuxada === null
                || this.state.SelPuxada === 0) {
                toastr.warning("Revenda não selecionada !!!!")
                podeenviar = false;
            }
        }

        if (podeenviar === true) {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaCustGprPcgRegistros(
                this.state.arrayEnviarTodos_groupId
                , this.state.arrayEnviarTodos_customerId
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_groupId: []
                    , arrayEnviar_customerId: []
                    , isModalOpen: 0
                    // , loading: true

                });
            }, 4000);
        }
    }

    // componentDidMount() {
    //     setTimeout(() => {
    //         this.setState({
    //             //loading: false,
    //             records: this.props.redListaCustGprPcg || []
    //         })
    //     }, 3000);
    // }

    render() {
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Customer Group</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ fontSize: "18px", color: "#77b935" }}
                            data-toggle="tooltip"
                            title="Adiciona a Lista"
                            onClick={this.setbscInf}

                        >
                            <i className="fa fa-refresh " aria-hidden="true"></i>
                        </button>
                    </div>
                    <br />
                    <br />
                </div>
                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div>
                    <ReactDatatable
                        config={this.config}
                        records={(this.state.booLerRecords === true ? this.props.redListaCustGprPcg || [] : [])}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    // loading={this.state.loading}
                    />
                </div>

                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                        </div>
                    </Modal.Body>

                </Modal>

            </div>
        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , redListaCustGprPcg: state.custGprPcgReducer.listacustGprPcg
        , redListaTdsRevendas: state.priceReducer.ListaTdsRevendas
    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getData
        , enviaCustGprPcgRegistros
        , logout
        , getDataTdsRevendas
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CustGprPcg)